import { userConstants } from '../constants';

export function downloads(state = {}, action) {
    switch (action.type) {
      case userConstants.GETALL_SUCCESS:
        console.log("Reducer set payload to: " + action.payload);
        return { ...state, downloads: action.payload.data };
      case userConstants.GETALL_FAILURE:
        return {
          status: action.payload.status,
          errorMessage: action.payload.errorMessage
        };
      default:
        return state
    }
  }